import { ajax } from "../services/ajax";
import { api } from "../constants";
export const getAnalysisReportsRequest = ({
  startDate,
  endDate,
  id,
  type,
  loginState
}) => ajax.get(
  api.endpoints.report.recommender.analysis({
    startDate,
    endDate,
    id,
    type,
    loginState
  })
)

export const getNewUserReportRequest = ({
  startDate,
  endDate
}) => ajax.get(
  api.endpoints.report.user.register({ startDate, endDate })
)

export const getOfflineReportRequest = ({
  startDate,
  endDate
}) => ajax.get(
  api.endpoints.report.offline({ startDate, endDate })
)